import deactivated from './deactivated';

export default deactivated;
